/**
 * Reveals .ectra-custom-section when it enters the viewport (IntersectionObserver).
 * Negative rootMargin bottom + higher threshold = trigger later, so the motion
 * stays visible while scrolling (not already finished off-screen).
 */
(function () {
  const SECTION_CLASS = 'ectra-custom-section';
  const VISIBLE_CLASS = 'ectra-custom-section--visible';

  function reveal(section) {
    section.classList.add(VISIBLE_CLASS);
  }

  function init(rootEl) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      rootEl.querySelectorAll('.' + SECTION_CLASS).forEach(reveal);
      return;
    }

    const sections = rootEl.querySelectorAll('.' + SECTION_CLASS);
    if (!sections.length) return;

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            reveal(entry.target);
            obs.unobserve(entry.target);
          }
        });
      },
      {
        rootMargin: '0px 0px -18% 0px',
        threshold: 0.12,
      }
    );

    sections.forEach((section) => {
      observer.observe(section);
    });
  }

  document.addEventListener('DOMContentLoaded', () => init(document));

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:section:reorder', () => init(document));
  }
})();